import React, { useEffect, useRef, useState } from 'react';
import {
  Avatar,
  Box,
  Button,
  Card,
  CardActionArea,
  CardHeader,
  Divider,
  Grid,
  IconButton,
  keyframes,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Skeleton,
  styled,
  Typography,
} from '@mui/material';
import { grey } from '@mui/material/colors';
import CardContent from '@mui/material/CardContent';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import AiBot from '../../../images/output.png';
import CloseIcon from '@mui/icons-material/Close';
import { QuestionInput } from '../../SustainabilityChatbot/QuestionInput';
import { ErrorCircleRegular } from '@fluentui/react-icons';
import MessageBox from '../../Sustainability/chat/MessageBox';
import { Answer } from '../../SustainabilityChatbot/Answer';
import styles from '../../Sustainability/chat/Chat.module.css';
import { Stack } from '@fluentui/react';
import HeaderLogo from '../../Sustainability/chat/HeaderLogo';
import apiClient from '../../../services/apiClient';
import { UserManager } from 'oidc-client';
import { authSettings } from '../../../data';
import { isEmpty } from 'lodash-es';
import StrategyShow from '../../news/StrategyShow/StrategyShow';
import UpdateShow from '../../news/UpdateShow/UpdateShow';
import BuyinNewsShow from '../../news/BuyinNewsShow/BuyinNewsShow';
import { useMatch } from 'react-router';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ContactsIcon from '../../shared/Icons/ContactsIcon';
import UpdatesIcon from '../../shared/Icons/UpdatesIcon';
import NegotiationsIcon from '../../shared/Icons/NegotiationsIcon';
import SustainabilityIcon from '../../shared/Icons/SustainabilityIcon';
import { AutoGraph, Insights } from '@mui/icons-material';

import { Stack as MuiStack } from '@mui/material';
import { Bot } from '../../MarketResearchChatbot/MarketReasearchChatbot';
import publicNewsIcon from '../../../images/publicNews.png';
import DomainGuard from '../../shared/DomainGuard/DomainGuard';
import { useAuth } from '../../AuthProvider';
import StrategiesIcon from '../../shared/Icons/StrategiesIcon';

const enum messageStatus {
  NotRunning = 'Not Running',
  Processing = 'Processing',
  Done = 'Done',
}

const moveBottom = keyframes`
  from {
    bottom: -100%;
    }
    to {
      bottom: 0;
  }
`;

const expandAnimation = keyframes`
  from {
    width: 45%;
    top: calc(100vh - 480px);
    bottom: 0;

  }
  to {
    width: 95%;
    top: 67px;
    bottom: 0;
  }
`;

const reduceAnimation = keyframes`
  from {
    width: 95%;
    top: 67px;
    bottom: 0;
  }
  to {
    bottom: 0;
    width: 30%;
    // top: calc(100vh - 450px);
  }
`;

const AnimatedCard = styled(Card)<{ isFirstOpen: boolean; expanded: boolean }>`
  animation: ${({ isFirstOpen, expanded }) =>
      isFirstOpen ? moveBottom : expanded ? expandAnimation : reduceAnimation}
    0.5s ease-in-out;
  animation-fill-mode: forwards;
  width: ${({ expanded }) => (expanded ? '95%' : '30%')};
`;

function MainWindow({
  height,
  onSelect,
}: {
  height: string;
  onSelect: (selection: any) => void;
}) {
  const { hasDomain } = useAuth();

  return (
    <List
      sx={{
        width: '100%',
        bgcolor: 'background.paper',
        height: height,
        display: 'flex',
        flexDirection: 'column',
        // justifyContent: 'center',
        alignItems: 'center',
        overflow: 'scroll',
        overflowX: 'hidden',
      }}
    >
      <Grid container>
        <Grid item xs={12} md={hasDomain(232000001) ? 6 : 12}>
          <ListItem
            sx={{
              width: '100%',
              padding: hasDomain(232000001) ? '5px' : '10px',
              paddingLeft: '10px',
              // paddingRight: '10px',
            }}
          >
            <CardActionArea
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'right',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '5px',
                paddingLeft: '10px',
                paddingRight: '10px',
                borderRadius: '14px',
                boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.2)',

                borderColor: 'primary.main',
                borderWidth: '2px',
                borderStyle: 'solid',
                minHeight: '120px',
              }}
              onClick={() => onSelect('news')}
            >
              <ListItemText
                className="icon-selected"
                primary={
                  <MuiStack
                    direction="row"
                    alignItems="top"
                    justifyContent="flex-start"
                    width={'100%'}
                  >
                    <StrategiesIcon
                      width={'20px'}
                      height={'20px'}
                      className="buyin-icon"
                    />
                    <Box minHeight={50} padding={0.5} marginTop={-0.5}>
                      <Typography variant="body2">News & Strategies</Typography>
                    </Box>
                  </MuiStack>
                }
                secondary="Chat with our category knowledge"
              />
            </CardActionArea>
          </ListItem>
        </Grid>
        <DomainGuard domainId={232000001}>
          <Grid item md={6} xs={6}>
            <ListItem
              sx={{
                width: '100%',
                padding: '5px',
                // paddingLeft: '10px',
                paddingRight: '10px',
                height: '100%',
              }}
            >
              <CardActionArea
                onClick={() => onSelect('devices-market-research')}
                sx={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'right',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: '5px',
                  borderRadius: '14px',
                  height: '100%',
                  boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.2)',
                  borderColor: 'primary.main',
                  borderWidth: '2px',
                  borderStyle: 'solid',
                  minHeight: '120px',
                  // cursor:
                }}
              >
                <ListItemText
                  className="icon-selected"
                  primary={
                    <MuiStack
                      direction="row"
                      alignItems="top"
                      justifyContent="flex-start"
                      width={'100%'}
                    >
                      <AutoGraph className="buyin-icon" />
                      <Box minHeight={50} padding={0.5} marginTop={-0.5}>
                        <Typography variant="body2">
                          Devices Market Research
                        </Typography>
                      </Box>
                    </MuiStack>
                  }
                  secondary="Expert knowledge on mobiles"
                />
              </CardActionArea>
            </ListItem>
          </Grid>
        </DomainGuard>

        <Grid item md={6} xs={12}>
          <ListItem
            sx={{
              width: '100%',
              padding: '5px',
              paddingLeft: '10px',
              // paddingRight: '10px',
              height: '100%',
            }}
          >
            <CardActionArea
              onClick={() => onSelect('sustainability')}
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'right',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '5px',
                borderRadius: '14px',
                height: '100%',
                boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.2)',
                borderColor: 'primary.main',
                borderWidth: '2px',
                borderStyle: 'solid',
                minHeight: '120px',
                // cursor:
              }}
            >
              <ListItemText
                className="icon-selected"
                primary={
                  <MuiStack
                    direction="row"
                    alignItems="top"
                    justifyContent="flex-start"
                    width={'100%'}
                  >
                    <SustainabilityIcon className="buyin-icon" />
                    <Box minHeight={50} padding={0.5} marginTop={-0.5}>
                      <Typography variant="body2">Sustainability</Typography>
                    </Box>
                  </MuiStack>
                }
                secondary="Supplier scores and more"
              />
            </CardActionArea>
          </ListItem>
        </Grid>
        <Grid item md={6} xs={12}>
          <ListItem
            sx={{
              width: '100%',
              padding: '5px',
              // paddingLeft: '10px',
              paddingRight: '10px',
              height: '100%',
            }}
          >
            <CardActionArea
              onClick={() => onSelect('contacts')}
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'right',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '5px',
                borderRadius: '14px',
                boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.2)',
                borderColor: 'primary.main',
                borderWidth: '2px',
                borderStyle: 'solid',
                height: '100%',
                minHeight: '120px',
              }}
            >
              <ListItemText
                className="icon-selected"
                primary={
                  <MuiStack
                    direction="row"
                    alignItems="top"
                    justifyContent="flex-start"
                    width={'100%'}
                  >
                    <ContactsIcon className="buyin-icon" />
                    <Box minHeight={50} padding={0.5} marginTop={-0.5}>
                      <Typography variant="body2">Contacts</Typography>
                    </Box>
                  </MuiStack>
                }
                secondary="Need to contact somebody at BuyIn?"
              />
            </CardActionArea>
          </ListItem>
        </Grid>
      </Grid>
    </List>
  );
}

export default function MbiNewsChatBot() {
  const match = useMatch('/domains/:tab/*');
  const isAdminPage = useMatch('/admin/*');
  const matchedTab: string | undefined = match?.params.tab;
  const [open, setOpen] = React.useState(true);
  const [isDisplayed, setIsDisplayed] = React.useState(false);
  const [isExpanded, setIsExpanded] = React.useState(false);
  const [ASSISTANT, TOOL, ERROR] = ['assistant', 'tool', 'error'];
  const [isLoading, setIsLoading] = React.useState(false);
  const [activeCitation, setActiveCitation] = React.useState<any>();
  const [articleId, setArticleId] = useState<number | null>(null);
  const [articleType, setArticleType] = useState<string | null>(null);
  const chatMessageStreamEnd = React.useRef<HTMLDivElement | null>(null);
  const [token, setToken] = useState<string | null>(null);
  const [showLoadingMessage, setShowLoadingMessage] =
    React.useState<boolean>(false);
  const [processMessages, setProcessMessages] = React.useState<messageStatus>(
    messageStatus.NotRunning,
  );
  const [isCitationPanelOpen, setIsCitationPanelOpen] =
    React.useState<boolean>(false);
  const [messages, setMessages] = React.useState<any>([]);

  const abortFuncs = useRef([] as AbortController[]);
  const [botConfig, setBotConfig] = React.useState<any>();
  const [conversationId, setConversationId] = useState<string>();
  const [isFirstOpen, setIsFirstOpen] = useState(true);
  const isPopupOpen = useRef(true);
  const [selection, setSelection] = useState<string | null>(null);
  const [title, setTitle] = useState<string | null>(null);
  const [subheader, setSubheader] = useState<string | null>(null);
  const [prompts, setPrompts] = useState<string[]>([]);
  const { profile } = useAuth();
  const [filter, setFilter] = useState<any>(null);

  const [datahubConversationId, setDatahubConversationId] = useState<
    string | undefined
  >();

  const datahubChatbotId = 2; // contacts for now

  useEffect(() => {
    if (profile?.isCustomer) {
      setFilter({
        user_type: 'natco',
        domain_code: profile.domains.map((d: any) => d.code).join(','),
        group: profile.groups.map((g: any) => g.code).join(','),
      });
      return;
    }
    setFilter({
      user_type: 'buyin',
    });
  }, [profile]);
  useEffect(() => {
    apiClient.get(`/mbnBots/1`).then((res: any) => {
      setBotConfig(res.data);
    });
  }, []);

  const parseCitationFromMessage = (message: any) => {
    if (message?.role && message?.role === 'tool') {
      try {
        const toolMessage = JSON.parse(message.content) as any;
        return toolMessage.citations;
      } catch {
        return [];
      }
    }
    return [];
  };

  const onShowCitation = (citation: any) => {
    const type = citation?.url?.replaceAll('//', '/')?.split('/')[3];
    switch (type) {
      case 'strategies':
        setArticleType('category-strategy');
        break;
      case 'updates':
        setArticleType('category-vendor-news');
        break;
      case 'buyin-news':
        setArticleType('buyin-news');
        break;
      default:
        setArticleType(null);
        break;
    }

    const urlArray = (citation?.url || '').split('/');
    const id =
      urlArray.length > 0 ? parseInt(urlArray[urlArray.length - 1]) : null;
    setArticleId(id);
    setActiveCitation(citation);
    setIsCitationPanelOpen(true);
  };

  const handleOpen = () => {
    setMessages([]);
    setSelection(null);
    setTitle(null);
    setSubheader(null);

    setOpen(!open);
    setIsExpanded(false);
    setIsFirstOpen(true);
  };

  useEffect(() => {
    (async () => {
      if (processMessages === messageStatus.Done) {
        const chatHistory = messages.map((message: any) => {
          return {
            role: message.role,
            content: message.content,
          };
        });
        // await conversationApi(
        //   {
        //     botConfig,
        //     messages: chatHistory.filter((answer: any) => answer.role === 'user')
        //   },
        //   new AbortController().signal,
        //   false,
        // );
      }
    })();
  }, [processMessages]);
  useEffect(() => {
    if (open && chatMessageStreamEnd.current && messages.length > 0)
      chatMessageStreamEnd.current?.scrollIntoView({ behavior: 'auto' });
  }, [messages]);

  useEffect(() => {
    console.log(isPopupOpen.current);
    if (isPopupOpen.current === true) {
      isPopupOpen.current = false;
      setTimeout(() => {
        setIsDisplayed(true);
      }, 3000);
    }
  }, [isPopupOpen.current]);

  async function conversationApi(
    options: any,
    abortSignal: AbortSignal,
    streamFromAzureApi = true,
    selected: string = 'news',
  ): Promise<Response> {
    const searchParams = new URLSearchParams();

    searchParams.append('streamFromAzureApi', streamFromAzureApi.toString());
    const url = `${process.env.REACT_APP_API_ENTRYPOINT}/api/mbnBots/conversation?${searchParams}`;

    const userManager = new UserManager(authSettings);
    const user = await userManager.getUser();
    const response = await fetch(
      `${process.env.REACT_APP_API_ENTRYPOINT}/api/mbnBots/conversation?${searchParams}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${user?.access_token}`,
        },
        body: JSON.stringify({
          ...options,
          conversationId,
        }),
        signal: abortSignal,
      },
    );

    return response;
  }

  async function makeDatahubRequest(
    message: string,
    selection: string | null,
    t: string | null = null,
  ) {
    const url = `${process.env.REACT_APP_DATAHUB_CHATBOT_API_URL}/message/`;

    setIsLoading(true);
    setShowLoadingMessage(true);
    const abortController = new AbortController();
    abortFuncs.current.unshift(abortController);

    const userMessage: any = {
      role: 'user',
      content: message,
    };

    setMessages([...messages, userMessage]);

    if (!t) {
      t = await getBearerToken();
      setToken(t);
    }

    const headers = {
      'Content-Type': 'application/json',
      'X-API-KEY': process.env.REACT_APP_X_API_KEY
        ? process.env.REACT_APP_X_API_KEY
        : '',
      Authorization: `Bearer ${t}`,
    };
    const data = {
      message: message,
      selection: selection,
      ...filter,
    };
    setIsLoading(true);
    // setIsStartAnswering(false);
    // setError(false);
    // setOpen(false);

    setProcessMessages(messageStatus.Processing);

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data),
        credentials: 'include',
      });
      // setIsStartAnswering(true);

      if (!response.ok) {
        let errorChatMsg: any = {
          role: ERROR,
          content:
            "There was an error generating a response. Chat history can't be saved at this time. If the problem persists, please contact the site administrator.",
        };
        setMessages([...messages, userMessage, errorChatMsg]);
        setIsLoading(false);
        setShowLoadingMessage(false);
        abortFuncs.current = abortFuncs.current.filter(
          (a) => a !== abortController,
        );
        setProcessMessages(messageStatus.Done);
        return;
      }

      if (response.status === 200) {
        setProcessMessages(messageStatus.NotRunning);
        const contentType = response.headers.get('Content-Type') || '';
        if (contentType.includes('application/json')) {
          try {
            const jsonResponse = await response.json();
            const data = JSON.parse(jsonResponse.data);
            const tHeaders = Object.keys(data[0]).reduce(
              (acc, key) => acc + `<th style="padding: 5px 10px">${key}</th>`,
              '',
            );

            const table = `<table>
                <thead>
                  <tr>
                    ${tHeaders}
                  </tr>
                </thead>
                <tbody>
                  ${data.reduce((acc: any, row: any) => {
                    const tData = Object.values(row).reduce(
                      (acc: any, value: any) =>
                        acc + `<td style="padding: 5px 10px">${value}</td>`,
                      '',
                    );
                    return acc + `<tr>${tData}</tr>`;
                  }, '')}
                </tbody>
              </table>`;
            const msgs = [
              ...messages,
              {
                role: 'user',
                content: message,
              },
              {
                role: 'assistant',
                content: table,
                excelContent: data,
              },
            ];
            setMessages(msgs);
            setIsLoading(false);
            setShowLoadingMessage(false);
            saveToDB(msgs,datahubChatbotId);

            return jsonResponse; // Return the JSON response for further use
          } catch (error) {
            setIsLoading(false);

            console.log('Failed to decode JSON response.');
          }
        } else if (contentType.includes('text/plain')) {
          console.log('Plain Text Streaming Response:');
          const reader = response.body?.getReader();
          const decoder = new TextDecoder('utf-8');
          let responseText = '';
          let done = false;
          let msgs: any = [];
          while (!done) {
            const { value, done: doneReading } = (await reader?.read()) || {
              value: null,
              done: true,
            };
            done = doneReading;
            if (value) {
              const decodedChunk = decoder.decode(value, { stream: true });

              responseText += decodedChunk;
            }
            msgs = [
              ...messages,
              {
                role: 'user',
                content: message,
              },
              {
                role: 'assistant',
                content: responseText,
              },
            ];
            setMessages(msgs);
          }

          // saveToDB(msgs, msgs[0].content).then(async (res) => {
          //   const currentChat = await res.json();

          //   appStateContext?.dispatch({
          //     type: 'UPDATE_CURRENT_CHAT',
          //     payload: {
          //       ...currentChat,

          //       date:
          //         currentChat?.date ||
          //         currentChat?.datahubMessages?.[0]?.date ||
          //         new Date().toISOString(),
          //     },
          //   });

          //   appStateContext?.dispatch({
          //     type: 'UPDATE_CHAT_HISTORY',
          //     payload: {
          //       ...currentChat,

          //       date:
          //         currentChat?.date ||
          //         currentChat?.datahubMessages?.[0]?.date ||
          //         new Date().toISOString(),
          //     },
          //   });
          // });
            saveToDB(msgs,datahubChatbotId);

          setIsLoading(false);
        } else {
          setProcessMessages(messageStatus.NotRunning);
          setIsLoading(false);
          console.log('Unexpected content type:', contentType);
        }
      } else {
        let errorChatMsg: any = {
          role: ERROR,
          content: 'There was an error generating a response.',
        };
        setMessages([...messages, userMessage, errorChatMsg]);
        setIsLoading(false);
        setShowLoadingMessage(false);
        abortFuncs.current = abortFuncs.current.filter(
          (a) => a !== abortController,
        );
        setIsLoading(false);
        console.log('Request failed with status code:', response.status);
      }
    } catch (error) {
      let errorChatMsg: any = {
        role: ERROR,
        content: 'There was an error generating a response.',
      };
      setMessages([...messages, userMessage, errorChatMsg]);
      setIsLoading(false);
      setShowLoadingMessage(false);
      abortFuncs.current = abortFuncs.current.filter(
        (a) => a !== abortController,
      );
      console.error('Request failed:', error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  }

  async function getBearerToken(): Promise<string | null> {
    const url = `${process.env.REACT_APP_DATAHUB_CHATBOT_API_URL}/chat-start/`;

    const headers = {
      'Content-Type': 'application/json',
      'X-API-KEY': process.env.REACT_APP_X_API_KEY || '',
    };
    const response = await fetch(url, {
      method: 'POST',
      headers,
    });

    if (response.status === 200) {
      const data = await response.json();
      return data.token;
    }
    console.log('Request failed with status code:', response.status);
    return null;
  }

  const makeApiRequest = async (question: string, selected: any) => {
    let assistantMessage = {} as any;
    let toolMessage = {} as any;
    let assistantContent = '';
    setIsLoading(true);
    setShowLoadingMessage(true);
    const abortController = new AbortController();
    abortFuncs.current.unshift(abortController);

    const userMessage: any = {
      role: 'user',
      content: question,
    };

    setMessages([...messages, userMessage]);

    const request: any = {
      botConfig,
      messages: [
        ...messages.filter((answer: any) => answer.role === 'user'),
        userMessage,
      ],
    };

    let result = {} as any;
    setProcessMessages(messageStatus.Processing);

    try {
      const response = await conversationApi(
        request,
        abortController.signal,
        true,
        selected,
      );
      if (!response.ok) {
        let errorChatMsg: any = {
          role: ERROR,
          content:
            "There was an error generating a response. Chat history can't be saved at this time. If the problem persists, please contact the site administrator.",
        };
        setMessages([...messages, userMessage, errorChatMsg]);
        setIsLoading(false);
        setShowLoadingMessage(false);
        abortFuncs.current = abortFuncs.current.filter(
          (a) => a !== abortController,
        );
        return;
      }
      if (response?.body) {
        const reader = response.body.getReader();
        let runningText = '';
        setProcessMessages(messageStatus.Done);

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          var text = new TextDecoder('utf-8').decode(value);
          const objects = text.split('\n');
          objects.forEach((obj) => {
            try {
              runningText += obj.replace('data:', '');

              result = JSON.parse(runningText);
              if (result.conversationId) {
                setConversationId(result.conversationId);
              }

              setShowLoadingMessage(false);
              result.choices[0].messages.forEach((resultMessage: any) => {
                if (resultMessage.role === ASSISTANT) {
                  assistantContent += resultMessage.content;
                  assistantMessage = resultMessage;
                  assistantMessage.content = assistantContent;
                }

                if (resultMessage.role === TOOL) {
                  toolMessage = resultMessage;
                }

                isEmpty(toolMessage)
                  ? setMessages([...messages, userMessage, assistantMessage])
                  : setMessages([
                      ...messages,
                      userMessage,
                      toolMessage,
                      assistantMessage,
                    ]);
              });

              runningText = '';
            } catch {}
          });
        }
      }
    } catch (e) {
      if (!abortController.signal.aborted) {
        let errorMessage =
          'An error occurred. Please try again. If the problem persists, please contact the site administrator.';
        if (result.error?.message) {
          errorMessage = result.error.message;
        } else if (typeof result.error === 'string') {
          errorMessage = result.error;
        }
        let errorChatMsg: any = {
          role: ERROR,
          content: errorMessage,
        };
        setMessages([...messages, errorChatMsg]);
      } else {
        setMessages([...messages, userMessage]);
      }
    } finally {
      setIsLoading(false);
      setShowLoadingMessage(false);
      abortFuncs.current = abortFuncs.current.filter(
        (a) => a !== abortController,
      );
      setProcessMessages(messageStatus.Done);
    }

    return abortController.abort();
  };

  const saveToDB = async (messages: any, datahubBotId: number) => {
    const userManager = new UserManager(authSettings);
    const user = await userManager.getUser();

    const response = (await fetch(
      `${process.env.REACT_APP_API_ENTRYPOINT}/api/datahubConversation`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${user?.access_token}`,
        },
        body: JSON.stringify({
          datahubConversation: {
            id: datahubConversationId,
            title: messages[0].content.slice(0, 100),
            messages: messages.filter((answer: any) => answer.role === 'user'),
            datahubChatbotId: datahubBotId,
          },
        }),
      },
    )).json();

    const res = (await (response));
    if (res.id) {
      setDatahubConversationId(res.id);
    }
    return res;
  };

  return isAdminPage ? null : (
    <Box
      sx={{
        display: isDisplayed ? 'block' : 'none',
      }}
    >
      {!articleId ? null : (
        <>
          {articleType === 'category-vendor-news' && (
            <UpdateShow
              isRoot
              id={articleId}
              onClose={() => {
                setArticleType(null);
                setArticleId(null);
              }}
            />
          )}
          {articleType === 'category-strategy' && (
            <StrategyShow
              id={articleId}
              onClose={() => {
                setArticleType(null);
                setArticleId(null);
              }}
            />
          )}
          {articleType === 'buyin-news' && (
            <BuyinNewsShow
              id={articleId}
              onClose={() => {
                setArticleType(null);
                setArticleId(null);
              }}
            />
          )}
        </>
      )}

      <AnimatedCard
        isFirstOpen={isFirstOpen}
        expanded={isExpanded}
        sx={{
          position: 'fixed',
          top: isExpanded ? 67 : 'auto',
          right: 0,
          zIndex: (theme) => theme.zIndex.drawer - 1,
          display: open ? 'block' : 'none',
          boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.2)',
        }}
      >
        <CardHeader
          style={{
            cursor: 'pointer',
          }}
          avatar={
            <Avatar
              className="icon-selected"
              sx={{
                backgroundColor: grey[200],
              }}
            >
              {selection === 'news' ? (
                <StrategiesIcon className="buyin-icon" />
              ) : selection === 'sustainability' ? (
                <SustainabilityIcon className="buyin-icon" />
              ) : selection === 'contacts' ? (
                <ContactsIcon className="buyin-icon" />
              ) : selection === 'devices-market-research' ? (
                <Insights />
              ) : (
                <img src={AiBot} width={45} height={45} />
              )}
            </Avatar>
          }
          action={
            <>
              <>
                <IconButton onClick={handleOpen}>
                  <CloseIcon />
                </IconButton>
                <IconButton
                  onClick={() => {
                    setIsFirstOpen(false);
                    setIsExpanded(!isExpanded);
                  }}
                >
                  <OpenInFullIcon />
                </IconButton>
              </>

              {selection && (
                <IconButton
                  onClick={() => {
                    setSelection(null);
                    setIsExpanded(false);
                    setTitle(null);
                    setSubheader(null);
                    setMessages([]);
                  }}
                >
                  <ArrowBackIosNewIcon />
                </IconButton>
              )}
            </>
          }
          title={
            <Typography variant="body2">
              {title || 'myBuyIn.pro chatbot'}
            </Typography>
          }
          // subheader={subheader || "Pick your use case !"}
        />
        <Divider
          sx={{
            width: '100%',
            backgroundColor: grey[200],
          }}
        />

        <CardContent
          sx={{
            p: 0,
            width: 'auto',
          }}
        >
          {!selection ? (
            <MainWindow
              onSelect={(selection: any) => {
                setSelection(selection);
                setIsExpanded(true);

                setTitle(
                  selection === 'news'
                    ? 'News'
                    : selection === 'sustainability'
                    ? 'Sustainability'
                    : selection === 'contacts'
                    ? 'Contacts'
                    : selection === 'devices-market-research'
                    ? 'Devices Market Research'
                    : '',
                );

                setSubheader(
                  selection === 'news'
                    ? 'Summarize the latest industry news, or get up to speed on our category strategies'
                    : selection === 'sustainability'
                    ? 'Ask anything on sustainability including supplier scores'
                    : selection === 'contacts'
                    ? 'Need to contact somebody at BuyIn? Start here'
                    : selection === 'devices-market-research'
                    ? 'Devices Market Research'
                    : '',
                );
                setPrompts(
                  selection === 'news'
                    ? [
                        'Provide the latest AI trends?',
                        'Could you share the Nokia news published in 2025?',
                        'What are the market trends in the IP Routers Category Strategy?',
                      ]
                    : selection === 'sustainability'
                    ? []
                    : selection === 'contacts'
                    ? [
                        'Who is responsible for Samsung?',
                        'Who is the CEO of BuyIn?',
                        'Which sourcers are responsible for Macro RAN?',
                      ]
                    : selection === 'devices-market-research'
                    ? []
                    : [],
                );
              }}
              height={
                isExpanded
                  ? 'calc(100vh - 280px)'
                  : (() => window.innerHeight / 2 - 67)() + 'px'
              }
            />
          ) : selection === 'news' ? (
            <>
              {!messages || messages.length < 1 ? (
                <HeaderLogo
                  title={
                    'Summarize the latest industry news, or get up to speed on our category strategies'
                  }
                  height={
                    isExpanded
                      ? 'calc(100vh - 280px)'
                      : (() => window.innerHeight / 2 - 67)() + 'px'
                  }
                  icon={
                    <Box className="icon-selected">
                      <StrategiesIcon
                        className="buyin-icon"
                        width={'170px'}
                        height={'170px'}
                      />
                    </Box>
                  }
                />
              ) : (
                <Box
                  component="div"
                  sx={{
                    p: 1,
                    width: 'auto',
                    zIndex: (theme) => theme.zIndex.appBar + 1,
                    height: isExpanded
                      ? 'calc(100vh - 280px)'
                      : (() => window.innerHeight / 2 - 67)() + 'px',
                    overflow: 'hidden',
                    overflowX: 'hidden',
                    overflowY: 'auto',
                  }}
                >
                  {messages.map((answer: any, index: number) => (
                    <React.Fragment key={index}>
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent:
                            answer.role === 'user' ? 'flex-end' : 'flex-start',
                          p: 0.5,
                        }}
                      >
                        {answer.role === 'user' ? (
                          <MessageBox
                            direction="right"
                            isFirst={messages[index - 1]?.role !== 'user'}
                            isLast={messages[index + 1]?.role !== 'user'}
                            hasNext={messages[index + 1]?.role === 'user'}
                          >
                            {answer.content}
                          </MessageBox>
                        ) : answer.role === 'assistant' ? (
                          <MessageBox direction="left">
                            <Answer
                              answer={{
                                answer: answer.content,
                                citations: parseCitationFromMessage(
                                  messages[index - 1],
                                ),
                              }}
                              onCitationClicked={(c) => onShowCitation(c)}
                            />
                          </MessageBox>
                        ) : answer.role === ERROR ? (
                          <div className={styles.chatMessageError}>
                            <Stack
                              horizontal
                              className={styles.chatMessageErrorContent}
                            >
                              <ErrorCircleRegular
                                className={styles.errorIcon}
                                style={{ color: 'rgba(182, 52, 67, 1)' }}
                              />
                              <span>Error</span>
                            </Stack>
                            <span className={styles.chatMessageErrorContent}>
                              {answer.content}
                            </span>
                          </div>
                        ) : null}
                      </Box>
                    </React.Fragment>
                  ))}
                  {isLoading &&
                    processMessages === messageStatus.Processing && (
                      <Box
                        sx={{
                          backgroundColor: grey[100],
                          borderRadius: '20px 20px 20px 0px',
                          marginTop: 1,
                          marginBottom: 1,
                          padding: 2,
                          width: '70%',
                        }}
                      >
                        <Skeleton
                          animation="pulse"
                          height={10}
                          width={'80%'}
                          style={{
                            position: 'relative',
                            marginBottom: 6,
                            color: 'rgba(0, 0, 0, 0.54)',
                          }}
                        />
                        <Skeleton
                          animation="pulse"
                          height={10}
                          width={'50%'}
                          style={{
                            marginBottom: 6,
                            color: 'rgba(0, 0, 0, 0.54)',
                          }}
                        />
                        <Skeleton
                          animation="pulse"
                          height={10}
                          width={'70%'}
                          style={{
                            marginBottom: 6,
                            color: 'rgba(0, 0, 0, 0.54)',
                          }}
                        />
                      </Box>
                    )}
                  <div ref={chatMessageStreamEnd} />
                </Box>
              )}
            </>
          ) : selection === 'sustainability' ? (
            <Bot
              isExpanded={isExpanded}
              open
              setOpen={setOpen}
              onClose={() => {
                setSelection(null);
                setIsExpanded(false);
                setTitle(null);
                setSubheader(null);
                setOpen(false);
              }}
              id={2}
              botName="Sustainability"
              title={'Ask anything on sustainability including supplier scores'}
              logo={
                <Box className="icon-selected">
                  <SustainabilityIcon
                    className="buyin-icon"
                    width={'170px'}
                    height={'170px'}
                  />
                </Box>
              }
              icon={<SustainabilityIcon className="buyin-icon" />}
              onExpand={(e) => {
                setIsExpanded(e);
              }}
              onClickBack={() => {
                setSelection(null);
                setIsExpanded(false);
                setTitle(null);
                setSubheader(null);
              }}
            />
          ) : selection === 'devices-market-research' ? (
            <DomainGuard domainId={232000001}>
              <Bot
                isExpanded={isExpanded}
                open
                setOpen={setOpen}
                onClose={() => {
                  setSelection(null);
                  setIsExpanded(false);
                  setTitle(null);
                  setSubheader(null);
                  setOpen(false);
                }}
                title={
                  'Chat with hundreds of pages of market research from leading providers'
                }
                logo={
                  <Box className="icon-selected">
                    <AutoGraph
                      className="buyin-icon"
                      sx={{
                        width: '170px',
                        height: '170px',
                      }}
                    />
                  </Box>
                }
                onExpand={(e) => {
                  setIsExpanded(e);
                }}
                onClickBack={() => {
                  setSelection(null);
                  setIsExpanded(false);
                  setTitle(null);
                  setSubheader(null);
                }}
              />
            </DomainGuard>
          ) : selection === 'contacts' ? (
            <>
              {!messages || messages.length < 1 ? (
                <HeaderLogo
                  title={'Need to contact somebody at BuyIn? Start here'}
                  height={
                    isExpanded
                      ? 'calc(100vh - 280px)'
                      : (() => window.innerHeight / 2 - 67)() + 'px'
                  }
                  icon={
                    <Box className="icon-selected">
                      <ContactsIcon
                        className="buyin-icon"
                        width={'170px'}
                        height={'170px'}
                      />
                    </Box>
                  }
                />
              ) : (
                <Box
                  component="div"
                  sx={{
                    p: 1,
                    width: 'auto',
                    zIndex: (theme) => theme.zIndex.appBar + 1,
                    height: isExpanded
                      ? 'calc(100vh - 280px)'
                      : (() => window.innerHeight / 2 - 67)() + 'px',
                    overflow: 'hidden',
                    overflowX: 'hidden',
                    overflowY: 'auto',
                  }}
                >
                  {messages.map((answer: any, index: number) => (
                    <React.Fragment key={index}>
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent:
                            answer.role === 'user' ? 'flex-end' : 'flex-start',
                          p: 0.5,
                        }}
                      >
                        {answer.role === 'user' ? (
                          <MessageBox
                            direction="right"
                            isFirst={messages[index - 1]?.role !== 'user'}
                            isLast={messages[index + 1]?.role !== 'user'}
                            hasNext={messages[index + 1]?.role === 'user'}
                          >
                            {answer.content}
                          </MessageBox>
                        ) : answer.role === 'assistant' ? (
                          <MessageBox direction="left">
                            <Answer
                              answer={{
                                answer: answer.content,
                                citations: parseCitationFromMessage(
                                  messages[index - 1],
                                ),
                              }}
                              onCitationClicked={(c) => onShowCitation(c)}
                            />
                          </MessageBox>
                        ) : answer.role === ERROR ? (
                          <div className={styles.chatMessageError}>
                            <Stack
                              horizontal
                              className={styles.chatMessageErrorContent}
                            >
                              <ErrorCircleRegular
                                className={styles.errorIcon}
                                style={{ color: 'rgba(182, 52, 67, 1)' }}
                              />
                              <span>Error</span>
                            </Stack>
                            <span className={styles.chatMessageErrorContent}>
                              {answer.content}
                            </span>
                          </div>
                        ) : null}
                      </Box>
                    </React.Fragment>
                  ))}
                  {isLoading &&
                    processMessages === messageStatus.Processing && (
                      <Box
                        sx={{
                          backgroundColor: grey[100],
                          borderRadius: '20px 20px 20px 0px',
                          marginTop: 1,
                          marginBottom: 1,
                          padding: 2,
                          width: '70%',
                        }}
                      >
                        <Skeleton
                          animation="pulse"
                          height={10}
                          width={'80%'}
                          style={{
                            position: 'relative',
                            marginBottom: 6,
                            color: 'rgba(0, 0, 0, 0.54)',
                          }}
                        />
                        <Skeleton
                          animation="pulse"
                          height={10}
                          width={'50%'}
                          style={{
                            marginBottom: 6,
                            color: 'rgba(0, 0, 0, 0.54)',
                          }}
                        />
                        <Skeleton
                          animation="pulse"
                          height={10}
                          width={'70%'}
                          style={{
                            marginBottom: 6,
                            color: 'rgba(0, 0, 0, 0.54)',
                          }}
                        />
                      </Box>
                    )}
                  <div ref={chatMessageStreamEnd} />
                </Box>
              )}
            </>
          ) : null}
          {selection && <Divider />}
        </CardContent>
        <Box
          sx={{
            p: 1,
          }}
        >
          {/* {selection && (
            <Grid container spacing={1} padding={1}>
              {prompts.map((p: string, index: number) => (
                <Grid item xs={isExpanded ? 4 : 12} key={index}>
                  <Button
                    disabled={isLoading}
                    key={index}
                    variant="outlined"
                    sx={{
                      textTransform: 'none',
                      width: '100%',
                      height: '40px',
                      p: 1,
                    }}
                    onClick={() => {
                      selection === 'news'
                        ? makeApiRequest(p, selection)
                        : makeDatahubRequest(p, selection, token);
                    }}
                  >
                    <Typography
                      // variant="subtitle2"
                      sx={{
                        textTransform: 'none',
                        color: (theme: any) => theme.palette.primary.main,
                        fontSize: '11px',
                      }}
                    >
                      {p}
                    </Typography>
                  </Button>
                </Grid>
              ))}
            </Grid>
          )} */}
          {selection && (
            <QuestionInput
              isLoading={isLoading}
              placeholder="Type a new question..."
              disabledButton={
                isLoading || !selection || (messages && messages.length === 0)
              }
              clearOnSend
              onStopGeneration={() => {
                abortFuncs.current.forEach((a) => a.abort());
                setShowLoadingMessage(false);
                setIsLoading(false);
              }}
              onSend={(message) => {
                setIsLoading(true);
                selection === 'news'
                  ? makeApiRequest(message, selection)
                  : makeDatahubRequest(message, selection, token);
              }}
              disabled={!selection}
              onDeleteClick={() => {
                setMessages([]);
                setToken(null);
                setDatahubConversationId(undefined);
              }}
              displayChatHistoryButton={false}
            />
          )}
        </Box>
      </AnimatedCard>
      <img
        onClick={handleOpen}
        style={{
          position: 'fixed',
          bottom: 50,
          right: 10,
          cursor: 'pointer',
          zIndex: 9999,
          width: '75px',
          height: '75px',
          display: open ? 'none' : 'block',
        }}
        width={200}
        src={AiBot}
      />
    </Box>
  );
}
